import { render, staticRenderFns } from "./ArtikelEdit.vue?vue&type=template&id=70a188e2&"
import script from "./ArtikelEdit.vue?vue&type=script&lang=js&"
export * from "./ArtikelEdit.vue?vue&type=script&lang=js&"
import style0 from "./ArtikelEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports